// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Base Reset and Typography */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.15s ease;
  cursor: pointer;
  border: none;
  outline: none;
}

.btn:focus-visible {
  outline: 2px solid #9ca3af;
  outline-offset: 2px;
}

.btn:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.btn-primary {
  background-color: #28adc2;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-primary:hover {
  background-color: #1f2937;
}

.btn-secondary {
  background-color: #f3f4f6;
  color: #111827;
}

.btn-secondary:hover {
  background-color: #e5e7eb;
}

.btn-ghost {
  background-color: transparent;
  color: #374151;
}

.btn-ghost:hover {
  background-color: #f3f4f6;
}

.btn-outline {
  background-color: #ffffff;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.btn-outline:hover {
  background-color: #f9fafb;
}

.btn-icon {
  background-color: #f3f4f6;
  color: #4b5563;
  width: 32px;
  height: 32px;
  padding: 0;
}

.btn-icon:hover {
  background-color: #e5e7eb;
}

.btn-sm {
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
}

.btn-md {
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
}

.btn-lg {
  height: 44px;
  padding: 0 32px;
  font-size: 16px;
}

/* Badge Styles */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid;
}

.badge-success {
  background-color: #dcfce7;
  color: #15803d;
  border-color: #bbf7d0;
}

.badge-default {
  background-color: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}

/* Header Styles */
.header {
  height: 56px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title h1 {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-nav-group {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.header-nav-group .btn-icon:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 1px solid #e5e7eb;
}

.header-nav-group .btn-icon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.menu-btn {
  padding: 4px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #4b5563;
  cursor: pointer;
}

.menu-btn:hover {
  background-color: #f3f4f6;
}

/* Sidebar Styles */
.sidebar {
  width: 288px;
  flex-shrink: 0;
  border-right: 1px solid #e5e7eb;
  background-color: #ffffff;
  min-height: calc(100vh - 56px);
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.profile-placeholder {
  aspect-ratio: 1;
  background-color: #c1ecf8;
  border-radius: 8px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.profile-placeholder svg {
  width: 48px;
  height: 48px;
  opacity: 0.2;
}

.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
}

.sidebar-item:hover {
  background-color: #f9fafb;
}

.sidebar-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #4b5563;
}

.sidebar-item-content svg {
  width: 16px;
  height: 16px;
}

.sidebar-item-content span {
  font-size: 14px;
  font-weight: 500;
}

.sidebar-item-action {
  color: #9ca3af;
  opacity: 0;
  transition: opacity 0.15s ease;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.sidebar-item:hover .sidebar-item-action {
  opacity: 1;
}

.sidebar-item-action:hover {
  color: #4b5563;
}

.sidebar-item-action svg {
  width: 16px;
  height: 16px;
}



.sidebar-engagement {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  color: #6b7280;
}

.engagement-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
}

.engagement-btn:hover {
  color: #374151;
}

.engagement-btn svg {
  width: 16px;
  height: 16px;
}

.follow-btn {
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.05em;
  background: transparent;
  border: none;
  cursor: pointer;
}

.follow-btn:hover {
  color: #111827;
}

.sidebar-timestamps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
  color: #9ca3af;
}

/* Main Layout */
.app-layout {
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.main-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.main-content {
  flex: 1 1;
  overflow-y: auto;
}

/* Tabs Navigation */
.tabs-container {
  border-bottom: 1px solid #e5e7eb;
  padding: 0 24px;
}

.tabs-nav {
  display: flex;
  gap: 24px;
  overflow-x: auto;
}

.tabs-nav::-webkit-scrollbar {
  display: none;
}

.tab-btn {
  white-space: nowrap;
  padding: 16px 0;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tab-btn:hover {
  color: #374151;
  border-bottom-color: #d1d5db;
}

.tab-btn.active {
  color: #111827;
  border-bottom-color: #111827;
}

/* Tab Content */
.tab-content {
  padding: 24px;
  max-width: 1152px;
}

/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px 0;
  background: transparent;
  border: none;
  cursor: pointer;
}

.section-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.section-header svg {
  width: 16px;
  height: 16px;
  color: #9ca3af;
  transition: color 0.15s ease;
}

.section-header:hover svg {
  color: #4b5563;
}

/* Activity Heatmap */
.heatmap-container {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 16px;
}

.heatmap-inner {
  min-width: 800px;
}

.heatmap-months {
  display: flex;
  margin-bottom: 8px;
  padding-left: 32px;
}

.heatmap-month {
  flex: 1 1;
  font-size: 10px;
  color: #6b7280;
  text-transform: uppercase;
  text-align: center;
}

.heatmap-grid-container {
  display: flex;
}

.heatmap-days {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 8px;
  font-size: 10px;
  color: #6b7280;
  height: 84px;
  padding: 4px 0;
}

.heatmap-grid {
  flex: 1 1;
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(7, 1fr);
  gap: 4px;
}

.heatmap-cell {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background-color: #f3f4f6;
}

.heatmap-cell.active {
  background-color: #16a34a;
}

.heatmap-note {
  margin-top: 16px;
  font-size: 12px;
  color: #6b7280;
}

/* Connection Group */
.connection-group {
  display: flex;
  flex-direction: column;
}

.connection-group h3 {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 12px;
}

.connection-items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.connection-item {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}

.connection-btn {
  display: flex;
  align-items: center;
  background-color: #c1ecf8;
  color: #374b51;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.connection-btn:hover {
  background-color: #e5e7eb;
}

.connection-count {
  background-color: #ffffff;
  color: #4b5563;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  border: 1px solid #e5e7eb;
}

.connection-add-btn {
  padding: 6px;
  background-color: #f3f4f6;
  color: #4b5563;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.connection-add-btn:hover {
  background-color: #e5e7eb;
}

.connection-add-btn svg {
  width: 16px;
  height: 16px;
}

/* Connections Grid */
.connections-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px 40px;
  margin-top: 16px;
}

@media (max-width: 1024px) {
  .connections-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .connections-grid {
    grid-template-columns: 1fr;
  }
}

/* Tab Content Cards */
.content-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
}

.content-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: #111827;
}

.stat-card {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.salary-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
}

.salary-row:last-child {
  border-bottom: none;
  font-weight: 600;
}

.salary-label {
  color: #4b5563;
}

.salary-value {
  color: #111827;
}

.salary-value.positive {
  color: #16a34a;
}

.salary-value.negative {
  color: #dc2626;
}

.timeline-item {
  display: flex;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}

.timeline-item:last-child {
  border-bottom: none;
}

.timeline-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #3b82f6;
  margin-top: 4px;
  flex-shrink: 0;
}

.timeline-content h4 {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}

.timeline-content p {
  font-size: 12px;
  color: #6b7280;
}

.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: #6b7280;
}

.empty-state svg {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  opacity: 0.3;
}

.empty-state p {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage.css"],"names":[],"mappings":";AACA,8BAA8B;AAC9B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;;AAGA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n/* Base Reset and Typography */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n\n.btn:focus-visible {\n  outline: 2px solid #9ca3af;\n  outline-offset: 2px;\n}\n\n.btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.btn-primary {\n  background-color: #28adc2;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.btn-primary:hover {\n  background-color: #1f2937;\n}\n\n.btn-secondary {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\n.btn-secondary:hover {\n  background-color: #e5e7eb;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: #374151;\n}\n\n.btn-ghost:hover {\n  background-color: #f3f4f6;\n}\n\n.btn-outline {\n  background-color: #ffffff;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n}\n\n.btn-outline:hover {\n  background-color: #f9fafb;\n}\n\n.btn-icon {\n  background-color: #f3f4f6;\n  color: #4b5563;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n\n.btn-icon:hover {\n  background-color: #e5e7eb;\n}\n\n.btn-sm {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n\n.btn-md {\n  height: 36px;\n  padding: 0 16px;\n  font-size: 14px;\n}\n\n.btn-lg {\n  height: 44px;\n  padding: 0 32px;\n  font-size: 16px;\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n.badge-success {\n  background-color: #dcfce7;\n  color: #15803d;\n  border-color: #bbf7d0;\n}\n\n.badge-default {\n  background-color: #f3f4f6;\n  color: #374151;\n  border-color: #e5e7eb;\n}\n\n/* Header Styles */\n.header {\n  height: 56px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-title h1 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-nav-group {\n  display: flex;\n  align-items: center;\n  margin-right: 8px;\n}\n\n.header-nav-group .btn-icon:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 1px solid #e5e7eb;\n}\n\n.header-nav-group .btn-icon:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.menu-btn {\n  padding: 4px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.menu-btn:hover {\n  background-color: #f3f4f6;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 288px;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e7eb;\n  background-color: #ffffff;\n  min-height: calc(100vh - 56px);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.profile-placeholder {\n  aspect-ratio: 1;\n  background-color: #c1ecf8;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n}\n\n.profile-placeholder svg {\n  width: 48px;\n  height: 48px;\n  opacity: 0.2;\n}\n\n.sidebar-nav {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n}\n\n.sidebar-item:hover {\n  background-color: #f9fafb;\n}\n\n.sidebar-item-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #4b5563;\n}\n\n.sidebar-item-content svg {\n  width: 16px;\n  height: 16px;\n}\n\n.sidebar-item-content span {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.sidebar-item-action {\n  color: #9ca3af;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.sidebar-item:hover .sidebar-item-action {\n  opacity: 1;\n}\n\n.sidebar-item-action:hover {\n  color: #4b5563;\n}\n\n.sidebar-item-action svg {\n  width: 16px;\n  height: 16px;\n}\n\n\n\n.sidebar-engagement {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n  color: #6b7280;\n}\n\n.engagement-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n}\n\n.engagement-btn:hover {\n  color: #374151;\n}\n\n.engagement-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.follow-btn {\n  margin-left: auto;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  letter-spacing: 0.05em;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.follow-btn:hover {\n  color: #111827;\n}\n\n.sidebar-timestamps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n/* Main Layout */\n.app-layout {\n  min-height: 100vh;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.main-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* Tabs Navigation */\n.tabs-container {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0 24px;\n}\n\n.tabs-nav {\n  display: flex;\n  gap: 24px;\n  overflow-x: auto;\n}\n\n.tabs-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.tab-btn {\n  white-space: nowrap;\n  padding: 16px 0;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.tab-btn:hover {\n  color: #374151;\n  border-bottom-color: #d1d5db;\n}\n\n.tab-btn.active {\n  color: #111827;\n  border-bottom-color: #111827;\n}\n\n/* Tab Content */\n.tab-content {\n  padding: 24px;\n  max-width: 1152px;\n}\n\n/* Section Header */\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 16px 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.section-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.section-header svg {\n  width: 16px;\n  height: 16px;\n  color: #9ca3af;\n  transition: color 0.15s ease;\n}\n\n.section-header:hover svg {\n  color: #4b5563;\n}\n\n/* Activity Heatmap */\n.heatmap-container {\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 16px;\n}\n\n.heatmap-inner {\n  min-width: 800px;\n}\n\n.heatmap-months {\n  display: flex;\n  margin-bottom: 8px;\n  padding-left: 32px;\n}\n\n.heatmap-month {\n  flex: 1;\n  font-size: 10px;\n  color: #6b7280;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.heatmap-grid-container {\n  display: flex;\n}\n\n.heatmap-days {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-right: 8px;\n  font-size: 10px;\n  color: #6b7280;\n  height: 84px;\n  padding: 4px 0;\n}\n\n.heatmap-grid {\n  flex: 1;\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-rows: repeat(7, 1fr);\n  gap: 4px;\n}\n\n.heatmap-cell {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  background-color: #f3f4f6;\n}\n\n.heatmap-cell.active {\n  background-color: #16a34a;\n}\n\n.heatmap-note {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Connection Group */\n.connection-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.connection-group h3 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 12px;\n}\n\n.connection-items {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.connection-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.connection-btn {\n  display: flex;\n  align-items: center;\n  background-color: #c1ecf8;\n  color: #374b51;\n  font-size: 14px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.connection-btn:hover {\n  background-color: #e5e7eb;\n}\n\n.connection-count {\n  background-color: #ffffff;\n  color: #4b5563;\n  font-size: 12px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-right: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.connection-add-btn {\n  padding: 6px;\n  background-color: #f3f4f6;\n  color: #4b5563;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.connection-add-btn:hover {\n  background-color: #e5e7eb;\n}\n\n.connection-add-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Connections Grid */\n.connections-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px 40px;\n  margin-top: 16px;\n}\n\n@media (max-width: 1024px) {\n  .connections-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .connections-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Tab Content Cards */\n.content-card {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.content-card h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 16px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-label {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.info-value {\n  font-size: 14px;\n  color: #111827;\n}\n\n.stat-card {\n  background-color: #f9fafb;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.salary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.salary-row:last-child {\n  border-bottom: none;\n  font-weight: 600;\n}\n\n.salary-label {\n  color: #4b5563;\n}\n\n.salary-value {\n  color: #111827;\n}\n\n.salary-value.positive {\n  color: #16a34a;\n}\n\n.salary-value.negative {\n  color: #dc2626;\n}\n\n.timeline-item {\n  display: flex;\n  gap: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.timeline-item:last-child {\n  border-bottom: none;\n}\n\n.timeline-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #3b82f6;\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.timeline-content h4 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.timeline-content p {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: #6b7280;\n}\n\n.empty-state svg {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 16px;\n  opacity: 0.3;\n}\n\n.empty-state p {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
